// Dashboard layout collapse state — the nav rail and the context sidebar. Shared
// by both components so each reacts to the other's width. See CLAUDE.md store rule.
import { createStore } from './create-store';

const [useIsNavCollapsed, , setIsNavCollapsed] = createStore(false);
export { useIsNavCollapsed, setIsNavCollapsed };

const [useIsContextCollapsed, , setIsContextCollapsed] = createStore(false);
export { useIsContextCollapsed, setIsContextCollapsed };
